export default __webpack_public_path__ + "static/compareItemImg4-dc0b649752a44ab921ae1f0107373556.webp";